import Vue from "vue";
import Vuex from "vuex";

// import vuex modules
import General from "@/store/general";
import User from "@/store/user";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        General,
        User
    },
    strict: process.env.NODE_ENV !== "production"
});
